import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { CatalogService } from "./catalog.service";
import { CurrentUserModel } from "../models/current-user.model";
import { LoginModel } from "../models/login.model";

@Injectable({
    providedIn: "root"
})
export class AccountService {

    private baseUrl: string = 'account';
    login_user: LoginModel = new LoginModel('', '');
    reenterpass_user: LoginModel = new LoginModel('', '');

    constructor(
        private api: ApiService,
        private catalogService: CatalogService
    ) {

    }

    login() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/login`, this.login_user)
                .subscribe((res: any) => {
                    // If API returns an error envelope like { message: ... } or { error: { message/title } }, reject so caller catch can show it
                    if (res && (res.message || (res.error && (res.error.message || res.error.title)))) {
                        reject(res);
                        return;
                    }
                    if (res) { 
                        //Commented by HRY
                        // localStorage.setItem('authenticated', JSON.stringify(true));
                        // localStorage.setItem('token', res.token);
                        // localStorage.setItem('currentUser', JSON.stringify(new CurrentUserModel(
                        //     res.Id,
                        //     res.RoleName,
                        //     res.Role,
                        //     res.email,
                        //     res.email,
                        //     res.Id,
                        //     res.clinic_no
                        // )));

                        // this.setUserToken(res.token);
                        // this.setUserRole(res.RoleName);
                        // this.setUserRoleNo(res.Role);

                        // this.user = new ApplicationUserModel(res.Id, res.UserName, res.NormalizedUserName, res.Email, res.NormalizedEmail, res.EmailConfirmed, res.PasswordHash, res.PhoneNumber, res.PhoneNumberConfirmed, res.TwoFactorEnabled, res.Role, res.RoleName, res.IsDeleted, res.IsActive);
                        resolve(res);
                    } else {
                        // this.user = new ApplicationUserModel(0, '', '', '', '', false, '', '', false, false, 0, '', false, false);
                        resolve(0);
                    }
                }, (res) => {
                    reject(res);
                });
        });
        return promise;
    }

    logout() {
        let promise = new Promise((resolve, reject) => {
            localStorage.removeItem('authenticated');
            localStorage.removeItem('token');
            localStorage.removeItem('currentUser');
            localStorage.removeItem('access_token');
            localStorage.removeItem('role');
            localStorage.removeItem('role_no');
            this.login_user = new LoginModel('', '');
            resolve(1);
        });
        return promise;
    }

    staff() {
        let currentUser = JSON.parse(localStorage.currentUser);
        // const requestBody = {
        //     loginModel: this.login_user,
        //     role: currentUser.Role
        //   };
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/staff?role=${currentUser.role_no}`, this.login_user)
                .subscribe((res: any) => { 
                    currentUser.employee_name = res.employee_name;
                    currentUser.employee_no = res.employee_no;
                    localStorage.setItem('currentUser', JSON.stringify(currentUser));
                    resolve(res);
                }, (res) => {
                    reject(res);
                });
        });
        return promise;
    }

    ChangeStaff(username: string){
        let currentUser = JSON.parse(localStorage.currentUser);
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/changeStaff?username=${username}`)
                .subscribe((res: any) => {
                    if(res > 0){
                        currentUser.employee_name = username;
                        currentUser.employee_no = res;
                        localStorage.setItem('currentUser', JSON.stringify(currentUser));
                        resolve(res);
                    }
                    else{
                        resolve(0);
                    }
                });
        })
        return promise;
    }

    validate(Token: string, Email:any, Role: number, clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/validateToken`, { Token: this.sanitize(Token), Email: this.sanitize(Email), Role: Role, clinic_no: clinic_no })
                .subscribe((res: any) => {
                    if (res) {
                        if (res.message) {
                            // this.user = new ApplicationUserModel(0, '', '', '', '', false, '', '', false, false, 0, '', false, false);
                            resolve(0);
                            return;
                        }
 
                         localStorage.setItem('authenticated', JSON.stringify(true));
                         localStorage.setItem('token', res[0].token);
                         console.log(res)
                            localStorage.setItem('currentUser', JSON.stringify(new CurrentUserModel(
                                res[0].Id,
                                res[0].RoleName,
                                res[0].Role,
                                res[0].email,
                                res[0].UserName,
                                res[0].Id,
                                res[0].clinic_no,
                                res[0].tenant_no
                            )));

                        this.setUserToken(res[0].token);
                        this.setUserRole(res[0].RoleName);
                        this.setUserRoleNo(res[0].Role);

                        this.catalogService.oneLoadCatalogs(clinic_no)//Newly added by HRY 2025/01/10
                        // this.user = new ApplicationUserModel(res.Id, res.UserName, res.NormalizedUserName, res.Email, res.NormalizedEmail, res.EmailConfirmed, res.PasswordHash, res.PhoneNumber, res.PhoneNumberConfirmed, res.TwoFactorEnabled, res.Role, res.RoleName, res.IsDeleted, res.IsActive);
                        resolve(1);
                    } else {
                        // this.user = new ApplicationUserModel(0, '', '', '', '', false, '', '', false, false, 0, '', false, false);
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    reenterpassword() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/login`, this.reenterpass_user)
                .subscribe((res: any) => {
                    if (res) {  
                        if (res.message) { 
                            resolve(0);
                            return;
                        } 
                        resolve(res);
                    } else {
                        // this.user = new ApplicationUserModel(0, '', '', '', '', false, '', '', false, false, 0, '', false, false);
                        resolve(0);
                    }
                }, (res) => {
                    reject(0);
                });
        });
        return promise;
    }


    private setUserToken(token: string) {
        localStorage.setItem('access_token', token);
    }

    private setUserRole(role: string) {
        localStorage.setItem('role', JSON.stringify(role));
    }

    private setUserRoleNo(role: number) {
        localStorage.setItem('role_no', JSON.stringify(role));
    }

    sanitize(text: string) {
        return text === null || text === undefined ? '' : text;
    }
}